<template>
	<div :class="$q.screen.gt.xs ? 'q-pa-xl' : 'q-pa-sm'">
		<h1 class="text-h5 q-pb-md q-my-md text-left fields-tab-header">
			Message Templates
		</h1>
		<MessageListScenarios :is_message_template="true" />
	</div>
</template>

<script>

import MessageListScenarios from '@/components/scenarios/message_scenarios_list/MessageListScenarios.vue';

export default {
	name: "MessageTemplates",
	meta: {
		title: 'Alert Cascade - Message Templates'
	},
	components: {
		MessageListScenarios
	},
};
</script>
